/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Select_All_Aria_LabelInputs */

const en_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select All Events with Errors`)
};

const fr_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner tous les evenements avec erreurs`)
};

const de_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Ereignisse mit Fehlern auswählen`)
};

const it_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutti gli eventi con errori`)
};

const ru_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбрать все события с ошибками`)
};

const es_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todos los eventos con errores`)
};

const zh_cn2_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择所有出错的事件`)
};

const ja_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラーのあるすべてのイベントを選択`)
};

const hi_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`त्रुटियों वाले सभी इवेंट चुनें`)
};

const pt_pt2_style_guide_select_all_aria_label = /** @type {(inputs: Style_Guide_Select_All_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar todos os eventos com erros`)
};

/**
* | output |
* | --- |
* | "Select All Events with Errors" |
*
* @param {Style_Guide_Select_All_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_select_all_aria_label = /** @type {((inputs?: Style_Guide_Select_All_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Select_All_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_select_all_aria_label(inputs)
	if (locale === "de") return de_style_guide_select_all_aria_label(inputs)
	if (locale === "it") return it_style_guide_select_all_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_select_all_aria_label(inputs)
	if (locale === "es") return es_style_guide_select_all_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_select_all_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_select_all_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_select_all_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_select_all_aria_label(inputs)
	return en_style_guide_select_all_aria_label(inputs)
});